const d =
	'M543-55v-107h138v107H543Zm-263 0v-149H-58l192-274H34l315-446 314 446h-99l193 274H418v149H280Zm528-149L644-436h98L506-775l105-149 315 446h-98l191 274H808Z';

export default d;
